import { IMAGES, TerminalImage } from "./TerminalImage";

const STATS = [
  {
    label: "Current Sector Size",
    value: "A$234.5B",
    note: "21.0% annual growth vs 5.5% bank loans.",
    testId: "stat-sector-size",
  },
  {
    label: "2029 Projection",
    value: "~A$300B",
    note: "EY-Parthenon capital deployment model.",
    testId: "stat-projection",
  },
  {
    label: "Top 10 Fund Share",
    value: "38.3%",
    note: "Institutional concentration in tier-1 credit.",
    testId: "stat-concentration",
  },
];

export const MarketData = () => (
  <section id="terminal-data" className="py-20 border-b border-line max-w-6xl mx-auto px-6" data-testid="market-data-section">
    <div className="mb-10">
      <span className="text-xs font-mono text-cy uppercase tracking-widest">[01] MARKET AGGREGATES</span>
      <h2 className="font-display text-4xl text-white uppercase mt-2">Institutional Debt Growth Matrix</h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 font-mono">
      {STATS.map((s) => (
        <div key={s.testId} className="p-6 rounded-xl bg-surface border border-line" data-testid={s.testId}>
          <div className="text-xs text-mut uppercase">{s.label}</div>
          <div className="text-4xl font-display text-white mt-1">{s.value}</div>
          <p className="text-xs text-cy mt-3">{s.note}</p>
        </div>
      ))}
    </div>

    <div className="mt-8 rounded-xl overflow-hidden border border-line">
      <TerminalImage
        src={IMAGES.market}
        alt="Debt capital flow data visualisation"
        testId="asic-band-visual"
        className="aspect-[21/6] drift-cyan p-6"
      >
        <div className="flex items-center justify-between gap-6 h-full flex-wrap">
          <div className="max-w-lg">
            <span className="text-xs font-mono text-cy uppercase">Regulatory Directive</span>
            <h3 className="font-display text-2xl text-white uppercase mt-1">ASIC Report 814 (Sept 2025)</h3>
            <p className="text-xs text-mut font-body">
              Enforcing valuation governance, conflict transparency, and consistent debt classification.
            </p>
          </div>
          <a
            href="#terminal-asic"
            data-testid="asic-inspect-cta"
            className="px-4 py-2 bg-cy text-navy font-mono text-xs font-bold rounded hover:bg-cy-soft transition-colors"
          >
            INSPECT BRIEF
          </a>
        </div>
      </TerminalImage>
    </div>
  </section>
);
